import { Select, Form } from "antd";
import { Controller } from "react-hook-form";
import { AntSelectProps } from "./types";
import colors from "theme/colors.module.scss";
import { Text } from "components/Text";
import {
    getBackgroundColorForTag,
    getColorForTag,
} from "helpers/colors.helper";

const { Option, OptGroup } = Select;

export const AntSelect = ({
    name,
    control,
    placeholder = "Wybierz opcję...",
    options,
    defaultValue,
    mode,
    showSearch = false,
    notFoundContent,
    onSearch,
    onChange,
    label,
    value,
    bgOptionColor = false,
    suffixIcon,
    onDropdownVisibleChange,
    onPopupScroll,
    filterOption = false,
    maxCount,
    open,
    loading = false,
    allowClear = false,
    disabled = false,
    }: AntSelectProps) => {
    return (
        <Form.Item>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                render={({ field, fieldState: { error } }) => (
                    <>
                        <Text $textVariant="labelBold" $textColor="text300">
                            {label}
                        </Text>

                        <Select
                            {...field}
                            filterOption={filterOption}
                            placeholder={placeholder}
                            defaultValue={defaultValue}
                            value={value}
                            loading={loading}
                            mode={mode}
                            open={open}
                            maxCount={maxCount}
                            size="large"
                            showSearch={showSearch}
                            notFoundContent={notFoundContent}
                            onChange={(value, option) => {
                                field.onChange(value);
                                if (onChange) onChange(value, option);
                            }}
                            onBlur={field.onBlur}
                            onSearch={onSearch}
                            suffixIcon={suffixIcon}
                            onDropdownVisibleChange={onDropdownVisibleChange}
                            onPopupScroll={onPopupScroll}
                            allowClear={allowClear}
                            disabled={disabled}
                        >
                            {options?.map((item) => {
                                // --- MULTIPLE SCOPES → GROUPS ---
                                if ((item as any).options) {
                                    return (
                                        <OptGroup key={item.title} label={item.label}>
                                            {(item as any).options.map((opt: any) => (
                                                <Option
                                                    key={opt.value}
                                                    value={opt.value}
                                                    selectorBg={opt.color}
                                                    labelString={opt.labelString}
                                                    style={{
                                                        color:
                                                            bgOptionColor &&
                                                            colors[getColorForTag(opt.color)],
                                                        backgroundColor:
                                                            bgOptionColor &&
                                                            colors[getBackgroundColorForTag(opt.color)],
                                                    }}
                                                >
                                                    {opt.label}
                                                </Option>
                                            ))}
                                        </OptGroup>
                                    );
                                }

                                // --- SINGLE SCOPE → NORMAL FLAT OPTIONS ---
                                return (
                                    <Option
                                        key={item.value}
                                        value={item.value}
                                        selectorBg={item.color}
                                        labelString={(item as any).labelString}
                                        style={{
                                            color:
                                                bgOptionColor &&
                                                colors[getColorForTag(item.color)],
                                            backgroundColor:
                                                bgOptionColor &&
                                                colors[getBackgroundColorForTag(item.color)],
                                        }}
                                    >
                                        {item.label}
                                    </Option>
                                );
                            })}
                        </Select>

                        {error && (
                            <span style={{ color: colors.accentRed500, marginTop: "4px" }}>
                                {error.message}
                             </span>
                        )}
                    </>
                )}
            />
        </Form.Item>
    );
};
